import NavBar from '../components/NavBar';
import TitleSection from '../components/TitleSection';
import CartList from '../components/CartList';
import Footer from '../components/Footer';
import UserCard from '../components/UserCard';
import HomeButton from '../components/HomeButton';
import ContentSection from '../components/ContentSection';
import VaultedCardsButton from '../components/VaultedCardsButton';
import { useSelector } from 'react-redux';
import RedirectButton from '../components/RedirectButton';
import { DropdownMenu } from '../components/DropdownMenu';
import LandingButton from '../components/LandingButton';

function CartPage() {
  const cart: Cart = useSelector((state: AppState) => state.cart)
  const isEmpty = (cart.items.length === 0)

  return (
    <div className='body'>
      <NavBar
        left={
          <>
            <HomeButton />
            <DropdownMenu>
              <LandingButton/>
              <VaultedCardsButton/>
            </DropdownMenu>
          </>
        }
        right={<UserCard />}
      />
      <TitleSection text='Your Cart'/>
      <ContentSection>
        <CartList />
        <div className='redirect-button'>
          <RedirectButton 
            display='Checkout' 
            url='/checkout' 
            className={`btn ${isEmpty ? 'gray' : 'green'} large`}
            disabled={isEmpty}
          />
        </div>
      </ContentSection>
      <Footer />
    </div>
  );
}

export default CartPage;
